import { HttpServices } from '../../Helper';
import { config } from '../../config';

const baseURL = `${config.server_address}/CrmDfm/PartnerHub`;
const GetVendorsAdvanceSearchAPI = async ({ pageSize, pageIndex }, body) => {
  const result = await HttpServices.post(
    `${baseURL}/VendorAdvanceSearch/${pageIndex + 1}/${pageSize}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const CreateVendorAPI = async (isFromExistContact, body) => {
  const result = await HttpServices.post(
    `${baseURL}/CreateVendor?isFromExistContact=${isFromExistContact}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response.data);
  return result;
};

const UpdateVendorAPI = async (vendorId, body) => {
  const result = await HttpServices.post(
    `${baseURL}/UpdateVendor/${vendorId}`,
    body
  );
  return result;
};

const GetVendorByIdAPI = async (vendorId) => {
  const result = await HttpServices.get(`${baseURL}/GetVendorById/${vendorId}`);
  return result;
};

const ViewVendorsAPI = async ({ pageIndex, pageSize, search }) => {
  const result = await HttpServices.get(
    `${baseURL}/ViewVendors/${pageIndex}/${pageSize}?search=${search}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const GetAllVendorServiceCategoriesAPI = async ({
  pageIndex,
  pageSize,
  search,
  vendorId,
}) => {
  const result = await HttpServices.get(
    `${baseURL}/GetAllVendorServiceCategories/${pageIndex}/${pageSize}?search=${search}&vendorId=${vendorId}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const CreateVendorAgreementAPI = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/CreateVendorAgreement`,
    body
  );
  return result;
};

const UpdateVendorAgreementAPI = async (vendorAgreementId, body) => {
  const result = await HttpServices.post(
    `${baseURL}/UpdateVendorAgreement/${vendorAgreementId}`,
    body
  );
  return result;
};

const GetAllVendorAgreementsAPI = async (vendorId, body) => {
  const result = await HttpServices.post(
    `${baseURL}/GetAllVendorAgreements/${vendorId}`,
    body
  );
  return result;
};

const GetVendorAgreementByIdAPI = async (vendorAgreementId, body) => {
  const result = await HttpServices.get(
    `${baseURL}/GetVendorAgreementById/${vendorAgreementId}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const DeleteVendorAgreementAPI = async (vendorAgreementId) => {
  const result = await HttpServices.delete(
    `${baseURL}/DeleteVendorAgreement/${vendorAgreementId}`
  );
  return result;
};
const CreateAgreementDocumentAPI = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/CreateAgreementDocument`,
    body
  );
  return result;
};

const UpdateAgreementDocumentAPI = async (agreementDocumentId, body) => {
  const result = await HttpServices.post(
    `${baseURL}/UpdateAgreementDocument/${agreementDocumentId}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const GetAllAgreementDocumentsAPI = async ({
  vendorAgreementId,
  pageIndex = 0,
  pageSize = 10,
}) => {
  const result = await HttpServices.get(
    `${baseURL}/GetAllAgreementDocuments/${vendorAgreementId}?pageIndex=${pageIndex}&pageSize=${pageSize}`
  );
  return result;
};

const GetAgreementDocumentByIdAPI = async (agreementDocumentId) => {
  const result = await HttpServices.get(
    `${baseURL}/GetAgreementDocumentById/${agreementDocumentId}`
  );
  return result;
};

const DeleteAgreementDocumentAPI = async (agreementDocumentId) => {
  const result = await HttpServices.delete(
    `${baseURL}/DeleteAgreementDocument/${agreementDocumentId}`
  );
  return result;
};

const CreateOrUpdateServiceSettingsAPI = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/CreateOrUpdateServiceSettings`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};
const GetServiceSettingByVendorIdAPI = async (vendorId) => {
  const result = await HttpServices.get(
    `${baseURL}/GetServiceSettingByVendorId/${vendorId}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const CreateVendorServiceAPI = async (body) => {
  const result = await HttpServices.post(`${baseURL}/CreateVendorService`, body)
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const UpdateVendorServiceAPI = async (vendorServiceId, body) => {
  const result = await HttpServices.post(
    `${baseURL}/UpdateVendorService/${vendorServiceId}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const GetAllVendorServicesAPI = async ({
  vendorId,
  pageIndex,
  pageSize,
  search,
}) => {
  const result = await HttpServices.get(
    `${baseURL}/GetAllVendorServices/${vendorId}?pageIndex=${pageIndex}&pageSize=${pageSize}&search=${search}`
  );
  return result;
};

const GetVendorServiceByIdAPI = async (vendorServiceId, body) => {
  const result = await HttpServices.get(
    `${baseURL}/GetVendorServiceById/${vendorServiceId}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const DeleteVendorServiceAPI = async (vendorServiceId) => {
  const result = await HttpServices.delete(
    `${baseURL}/DeleteVendorService/${vendorServiceId}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const CreateVendorOfferAPI = async (body) => {
  const result = await HttpServices.post(`${baseURL}/CreateVendorOffer`, body)
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const UpdateVendorOfferAPI = async (offerId, body) => {
  const result = await HttpServices.post(
    `${baseURL}/UpdateVendorOffer/${offerId}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const DeleteVendorOfferAPI = async (offerId, body) => {
  const result = await HttpServices.delete(
    `${baseURL}/DeleteVendorOffer/${offerId}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const GetVendorOfferByIdAPI = async (offerId) => {
  const result = await HttpServices.get(
    `${baseURL}/GetVendorOfferById/${offerId}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const GetFilteredVendorOffersAPI = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/GetFilteredVendorOffers`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const UpdateOfferStatusAPI = async ({ offerId, offerStatusId }) => {
  const result = await HttpServices.put(
    `${baseURL}/UpdateOfferStatus${offerId}/${offerStatusId}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

const ChangePublishStatusAPI = async ({ offerId, isPublished }) => {
  const result = await HttpServices.put(
    `${baseURL}/ChangePublishStatus${offerId}/${isPublished}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetAllVendorDocuments = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/GetAllVendorDocuments`,
    body
  );
  return result;
};

export const DeleteVendorDocument = async (vendorDocumentId) => {
  const result = await HttpServices.delete(
    `${baseURL}/DeleteVendorDocument/${vendorDocumentId}`
  );
  return result;
};

export const CreateVendorDocument = async (body) => {
  return await HttpServices.post(
    `${baseURL}/CreateVendorDocument`,
    body
  );
};

export const UpdateVendorDocument = async (vendorDocumentId, body) => {
  const result = await HttpServices.post(
    `${baseURL}/UpdateVendorDocument/${vendorDocumentId}`,
    body
  );
  return result;
};

export const GetVendorDocumentById = async (vendorDocumentId) => {
  const result = await HttpServices.get(
    `${baseURL}/GetVendorDocumentById/${vendorDocumentId}`
  );
  return result;
};

export const GetVendorActivities = async (vendorId, body) => {
  const result = await HttpServices.post(
    `${baseURL}/GetVendorActivities?vendorId=${vendorId}`,
    body
  );
  return result;
};

export const GetServiceSettingByVendorId = async (vendorId) => {
  const result = await HttpServices.get(
    `${baseURL}/GetServiceSettingByVendorId/${vendorId}`
  );
  return result;
};

export const CreateOrUpdateServiceSetting = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/CreateOrUpdateServiceSetting`,
    body
  );
  return result;
};

export const CreateVendorService = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/CreateVendorService`,
    body
  );
  return result;
};

export const UpdateVendorService = async (vendorServiceId, body) => {
  const result = await HttpServices.post(
    `${baseURL}/UpdateVendorService/${vendorServiceId}`,
    body
  );
  return result;
};

export const GetAllVendorServices = async (vendorId, params) => {
  const result = await HttpServices.get(
    `${baseURL}/GetAllVendorServices/${vendorId}`,
    { params }
  );
  return result;
};

export const DeleteVendorService = async (vendorServiceId) => {
  const result = await HttpServices.delete(
    `${baseURL}/DeleteVendorService/${vendorServiceId}`
  );
  return result;
};

export const GetAllVendorServiceCategories = async ({
  pageSize,
  pageIndex,
  vendorId,
}) => {
  const result = await HttpServices.get(
    `${baseURL}/GetAllVendorServiceCategories/${pageIndex}/${pageSize}`,
    { params: { vendorId } }
  );
  return result;
};

export const CreateVendorOffer = async (body) => {
  const result = await HttpServices.post(`${baseURL}/CreateVendorOffer`, body);
  return result;
};

export const UpdateVendorOffer = async (vendorOfferId, body) => {
  const result = await HttpServices.post(
    `${baseURL}/UpdateVendorOffer/${vendorOfferId}`,
    body
  );
  return result;
};

export const DeleteVendorOffer = async (vendorOfferId) => {
  const result = await HttpServices.delete(
    `${baseURL}/DeleteVendorOffer/${vendorOfferId}`
  );
  return result;
};

export const GetFilteredVendorOffers = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/GetFilteredVendorOffers`,
    body
  );
  return result;
};

export const UpdateOfferStatus = async ({ offerId, offerStatusId }) => {
  const result = await HttpServices.put(
    `${baseURL}/UpdateOfferStatus/${offerId}/${offerStatusId}`
  );
  return result;
};

export const ChangePublishStatus = async ({ offerId, isPublished }) => {
  const result = await HttpServices.put(
    `${baseURL}/ChangePublishStatus/${offerId}/${isPublished}`
  );
  return result;
};

export const ExportVendorOffersReport = async (filter, exportType) => {
  const result = await HttpServices.post(
    `${baseURL}/ExportVendorOffersReport`,
    { filter, exportType }
  );
  return result;
};

export const GetVendorActivityType = async () => {
  const result = await HttpServices.get(
    `${baseURL}/GetVendorActivityType`
  );
  return result;
}
export {
  GetVendorsAdvanceSearchAPI,
  ViewVendorsAPI,
  CreateVendorAPI,
  UpdateVendorAPI,
  GetVendorByIdAPI,
  GetAllVendorServiceCategoriesAPI,
  CreateVendorAgreementAPI,
  UpdateVendorAgreementAPI,
  GetAllVendorAgreementsAPI,
  GetVendorAgreementByIdAPI,
  DeleteVendorAgreementAPI,
  CreateAgreementDocumentAPI,
  UpdateAgreementDocumentAPI,
  GetAllAgreementDocumentsAPI,
  GetAgreementDocumentByIdAPI,
  DeleteAgreementDocumentAPI,
  CreateOrUpdateServiceSettingsAPI,
  GetServiceSettingByVendorIdAPI,
  CreateVendorServiceAPI,
  UpdateVendorServiceAPI,
  GetAllVendorServicesAPI,
  GetVendorServiceByIdAPI,
  DeleteVendorServiceAPI,
  CreateVendorOfferAPI,
  UpdateVendorOfferAPI,
  DeleteVendorOfferAPI,
  GetVendorOfferByIdAPI,
  GetFilteredVendorOffersAPI,
  UpdateOfferStatusAPI,
  ChangePublishStatusAPI,
};
